import { ActionType } from "./types/enums";
import { LoaderAction, LoaderState } from "./types/interfaces";

export const loaderReducer = (state: LoaderState, action: LoaderAction): LoaderState => {
  switch (action.type) {
    case ActionType.START_LOADING: {
      const { key } = action.payload;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [key]: true,
        },
        activeLoadersCount: state.activeLoadersCount + 1,
      };
    }

    case ActionType.STOP_LOADING: {
      const { key } = action.payload;
      const newLoaders = { ...state.loaders };
      delete newLoaders[key];

      return {
        ...state,
        loaders: newLoaders,
        activeLoadersCount: Math.max(0, state.activeLoadersCount - 1),
      };
    }

    case ActionType.START_GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: true,
      };

    case ActionType.STOP_GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: false,
      };

    case ActionType.SET_ERROR: {
      const { key, error, isGlobal } = action.payload;

      if (isGlobal) {
        return {
          ...state,
          globalError: error
        };
      }

      return {
        ...state,
        errors: {
          ...state.errors,
          [key as string]: error
        }
      };
    }

    case ActionType.CLEAR_ERROR: {
      const { key, isGlobal } = action.payload;

      if (isGlobal) {
        return {
          ...state,
          globalError: null
        };
      }

      const newErrors = { ...state.errors };
      delete newErrors[key as string];

      return {
        ...state,
        errors: newErrors
      };
    }

    default:
      return state;
  }
};
